import Breadcrumbs from '../../../layout/breadcrumbs';
import AdminSidebar from '../../../layout/admin-sidebar';
import { ChangeEvent, FormEvent, useState } from 'react';
import {
  PAYMENT_METHOD_TYPE_ENUM,
  PaymentMethod,
} from '../../../../interfaces';
import PaymentMethodForm from './partials/payment-method-form';
import { useCreatePaymentMethodMutation } from '../../../../services';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import { handleServerError } from '../../../../helpers';

const AddPaymentMethod = () => {
  const navigate = useNavigate();
  //@ts-ignore
  const [paymentMethod, setPaymentMethod] = useState<PaymentMethod>({
    name: "",
    type: PAYMENT_METHOD_TYPE_ENUM.crypto,
    currency: "",
    instruction: "",
  });

  const [create, { isLoading }] = useCreatePaymentMethodMutation();

  const onChange = (e: ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
    e.preventDefault();
    const { name, value } = e.target;
    setPaymentMethod(prevState => ({
      ...prevState,
      [name]: value,
    }));
  }

  const onSubmit = (e: FormEvent<HTMLFormElement>, instruction: string) => {
    e.preventDefault();
    create({ ...paymentMethod, instruction })
      .unwrap()
      .then(() => {
        toast.success('Payment Method created');
        navigate('/admin/payment/methods');
      })
      .catch(handleServerError);
  }

  return (
    <div id="page-content">
      <Breadcrumbs crumbs={[
        { page: 'Account', link: '/admin/profile' },
        { page: 'Properties', link: '/admin/properties' },
        { page: 'Create New PaymentMethod' }
      ]}/>

      <div className="container">
        <div className="row">
          <div className="col-md-3 col-sm-2">
            <AdminSidebar/>
          </div>
          <div className="col-md-9 col-sm-10">
            <PaymentMethodForm paymentMethod={paymentMethod} onSubmit={onSubmit}
                               onChange={onChange} setPaymentMethod={setPaymentMethod}
                               isLoading={isLoading} loadingText={'Creating...'}
                               submitText={'Create PaymentMethod'}/>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AddPaymentMethod;